import React from 'react';
import { useFormik } from 'formik';
import { Accordion, Button, TextField } from '../../../../components';

export type EmailConfigurationDetailProps = {
  id?: string;
  subject?: string;
  content?: string;
  placeholder?: string[];
  tags?: string[];
};

export const EmailManagement = (): React.ReactElement => {
  const formik = useFormik({
    initialValues: {
      sampleRate: 0.0,
      gsEmailList: '',
      bccEmailList: '',
    },
    // TODO
    onSubmit: values => {},
  });

  return (
    <div className="mt-12 mb-12 w-[50%] ml-4">
      <Accordion
        title={'Management'}
        details={
          <form onSubmit={formik.handleSubmit}>
            <div className="flex flex-col">
              <div className="flex flex-col m-4">
                <TextField
                  label="Sample Rate"
                  name="sampleRate"
                  value={formik.values.sampleRate}
                  onChange={formik.handleChange}
                />
              </div>
              <div className="flex flex-col m-4">
                <TextField
                  label="GS Email List"
                  name="gsEmailList"
                  value={formik.values.gsEmailList}
                  onChange={formik.handleChange}
                />
              </div>
              <div className="flex flex-col m-4">
                <TextField
                  label="BCC Email List"
                  name="bccEmailList"
                  value={formik.values.bccEmailList}
                  onChange={formik.handleChange}
                />
              </div>
              <Button type="submit" variant="outlined">
                Submit
              </Button>
            </div>
          </form>
        }
      />
    </div>
  );
};

export const EmailConfigurationDetail: React.FC<
  EmailConfigurationDetailProps
> = ({ subject, content, placeholder, tags }) => {
  let replacedContent = content?.replaceAll(
    /<a(.*?)>(.*?)<\/a>/g,
    '<span title="$1">$2</span>',
  );

  const regex = new RegExp(
    `{{(${placeholder
      ?.filter(item => item !== 'url' && item !== 'homepage')
      ?.join('|')})}}`,
    'g',
  );
  replacedContent = replacedContent?.replaceAll(
    regex,
    '<span style="font-weight: bold; background-color: yellow">$1</span>',
  );

  const tagElement = tags?.map((tag, index) => (
    <span key={index} className="border-2 border-grey-500 m-2 p-2 rounded">
      {tag}
    </span>
  ));

  return (
    <div className="p-4">
      <div className="m-4">
        <p>
          <b>Subject:</b> {subject}
        </p>
      </div>
      <div className="m-4">
        <p>
          <b>Tags:</b> {tagElement}
        </p>
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: replacedContent ?? '',
        }}
        className="m-4 p-4 border-2 border-grey-500"
      />
    </div>
  );
};
